import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { MultiLineD3Chart } from './MultiLineD3Chart';
import './MultiLineChart.css';

export class MultiLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPoints: [],
      unit: '',
      reportUnit: '',
      lineColorObj: {},
      name: '',
    };
    this.ref = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let dataPoints = [];
    if (nextProps.name === 'Diagnostics') {
      dataPoints = nextProps.diagnosticsData.data_points;
    } else if (nextProps.name === 'Thermostat') {
      dataPoints = nextProps.suiteData.point_data;
    }

    if (dataPoints) {
      const formattedDataPoints = {};

      dataPoints.forEach((dataset) => {
        formattedDataPoints[dataset.id] = dataset.graph_data.map((d) => ({
          date: moment(d.x),
          [dataset.id]: d.actual,
        }));
      });

      const unit = {};

      dataPoints.map((dataSet) => {
        unit[dataSet.id] = dataSet.unit;
        return unit;
      });

      const reportUnit =
        nextProps.name === 'Diagnostics' ? nextProps.diagnosticsData.interval : nextProps.suiteData.report_unit;

      const { diagnosticsLineColorObj, suiteLineColorObj, name } = nextProps;

      let lineColorObj = {};
      if (name === 'Diagnostics') {
        lineColorObj = diagnosticsLineColorObj;
      }
      if (name === 'Thermostat') {
        lineColorObj = suiteLineColorObj;
      }

      return {
        ...prevState,
        dataPoints: formattedDataPoints,
        unit,
        reportUnit,
        lineColorObj,
        name,
      };
    }
    return { ...prevState };
  }

  componentDidMount() {
    const node = this.ref.current;
    const { dataPoints, unit, reportUnit, lineColorObj = {}, name } = this.state;

    this.chart = new MultiLineD3Chart(node, dataPoints, unit, reportUnit, lineColorObj, name);
  }

  componentDidUpdate() {
    const { dataPoints, unit, reportUnit, lineColorObj = {} } = this.state;
    this.chart.update(dataPoints, unit, reportUnit, lineColorObj);
  }

  render() {
    return <div className="line-graph" ref={this.ref} />;
  }
}

function mapStateToProps(state) {
  return {
    diagnosticsData: state.diagnosticsReducer.diagnosticsData,
    thermostatData: state.suiteReducer.suiteData,
    diagnosticsLineColorObj: state.diagnosticsReducer.lineColorObj,
    suiteLineColorObj: state.suiteReducer.suiteLineColors,
  };
}

export const ConnectedMultiLineChart = connect(mapStateToProps)(MultiLineChart);
